import { ChainType as Type } from '@ankr.com/chains-list';

import { ChainTypeTab } from 'modules/chains/components/ChainTypeTab';
import { GroupedEndpoints } from 'modules/endpoints/types';
import { LockedTab } from 'modules/chains/components/LockedTab';
import { Tab } from 'modules/common/hooks/useTabs';

import { chainTypeMap } from '../constants';
import { getChainTypeTabs } from './getChainTypeTabs';

interface GetPrivateChainTypeTabsParams {
  canTabBeBlocked?: boolean;
  className?: string;
  endpoints: GroupedEndpoints;
  isBlockedMainnet?: boolean;
  isBlockedTestnet: boolean;
  isHiddenMainnet?: boolean;
  onBlockedTabClick?: () => void;
  onClick?: (id: Type) => void;
}

export const getPrivateChainTypeTabs = ({
  canTabBeBlocked,
  className,
  endpoints,
  isBlockedMainnet,
  isBlockedTestnet,
  isHiddenMainnet,
  onBlockedTabClick,
  onClick,
}: GetPrivateChainTypeTabsParams): Tab<Type>[] =>
  getChainTypeTabs()
    .filter(({ id }) => endpoints[chainTypeMap[id]]?.length > 0)
    .map<Tab<Type>>(({ id, title }, index, list) => {
      const blockedTestnet = isBlockedTestnet && id === Type.Testnet;
      const blockedMainnet = isBlockedMainnet && id === Type.Mainnet;
      const isBlocked = canTabBeBlocked && (blockedTestnet || blockedMainnet);
      const isHidden = isHiddenMainnet && id === Type.Mainnet;

      return {
        id,
        title: (isSelected: boolean) => {
          const resolvedTitle =
            typeof title === 'function' ? title(false, false, id) : title;

          const label = isBlocked ? (
            <LockedTab title={resolvedTitle} />
          ) : (
            resolvedTitle?.toString() || ''
          );

          const onTabClick = () => {
            onClick?.(id);

            if (isBlocked) {
              onBlockedTabClick?.();
            }
          };

          return (
            <ChainTypeTab
              className={className}
              isLast={index === list.length - 1}
              isSelected={!isBlocked && isSelected}
              label={label}
              onClick={onTabClick}
            />
          );
        },
        isDisabled: isBlocked || isHidden,
        isHidden,
      };
    });
